import React from "react";

export function StudioSectionHeader({ title, buttonText, expanded, canToggle, onToggle, totalCount }) {
  // 공통 헤더의 표현만 개선합니다. 펼침/접힘 여부와 이벤트는 기존 Starter에서 전달합니다.
  const count = Number(totalCount) || 0;
  const collapsedLabel = buttonText === "모든 템플릿 보기" ? "접기" : "접기";
  const content = (
    <>
      총 <span className="unified-section-count-num">{count}</span>개
      {canToggle ? (
        <>
          {" "}{expanded ? collapsedLabel : "전체보기"}
          <i className={expanded ? "fa fa-solid fa-angle-up" : "fa fa-solid fa-angle-right"} aria-hidden="true" />
        </>
      ) : null}
    </>
  );

  return (
    <div className="section-header unified-section-header">
      <div className="section-title unified-section-title">
        <h3>{title}</h3>
      </div>
      {canToggle ? (
        <button className="unified-section-link" type="button" onClick={onToggle} aria-expanded={!!expanded}>
          {content}
        </button>
      ) : (
        <span className="unified-section-link unified-section-count-only">{content}</span>
      )}
    </div>
  );
}

export function StudioFoldControl({ expanded, onToggle, label }) {
  return expanded ? (
    <div className="unified-bottom-fold">
      <button className="unified-toggle-button" type="button" onClick={onToggle}>
        <i className="fa fa-solid fa-chevron-up" aria-hidden="true" /> {label}
      </button>
    </div>
  ) : null;
}
